import { render, staticRenderFns } from "./user-exchange-list-code.vue?vue&type=template&id=65359b16&scoped=true&"
import script from "./user-exchange-list-code.vue?vue&type=script&lang=js&"
export * from "./user-exchange-list-code.vue?vue&type=script&lang=js&"
import style0 from "./user-exchange-list-code.vue?vue&type=style&index=0&id=65359b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65359b16",
  null
  
)

export default component.exports